export default {
  title: 'Histórico',
  summary: '{total} posição · retenção do plano: {days} dias | {total} posições · retenção do plano: {days} dias',
  all_devices: 'Todos os dispositivos',
  empty: 'Nenhuma posição no período.',
  table: {
    when: 'Quando',
    device: 'Dispositivo',
    position: 'Posição',
    accuracy: 'Precisão',
    battery: 'Bateria',
    source: 'Origem',
  },
}
